/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * CREATED — the definition came into being; as a copy, the change copiedFrom says of what. CHANGED — saved with the fields listed different. STATUS_CHANGED — made active, retired or brought back, as the field status. A save that changes nothing leaves no event.
 * @export
 * @enum {string}
 */

export const DefinitionEventKindDto = {
    Created: 'CREATED',
    Changed: 'CHANGED',
    StatusChanged: 'STATUS_CHANGED'
} as const;

export type DefinitionEventKindDto = typeof DefinitionEventKindDto[keyof typeof DefinitionEventKindDto];



